module.exports = __webpack_public_path__ + "static/media/dnd_indicator.fd3e0d68.svg";